import { styled } from "@mui/material/styles";
const OrdersMain = styled("div")(({ theme }) => ({
  marginTop: "30px",
}));

export { OrdersMain };
